import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { KeycloakService } from '@resident-nx/web/data-access';

export const LoginPageGuard: CanActivateFn = () => {
  const keycloakService = inject(KeycloakService);
  const router = inject(Router);

  const { token, authenticated } = keycloakService.instance || {};

  if (!token || !authenticated) return true;

  return new RedirectCommand(router.parseUrl(''));
};
